const pt = {
  100000001:'Informação chave',
  100000002:'Moeda Token',
  100000003:'Criador de cópias',
  100000004:'Tempo de Criação da Instância',
  100000005:'Informações básicas',
  100000006:'Chain/protocolo associado',
  100000007:'Endereço do contrato',
  100000008:'Data da Emissão',
  100000009:'Oferta Total',
  100000010:'Oferta Circulante',
  100000011:'Valor de Mercado',
  100000012:'Informações',
  100000013:'Informações de redes sociais',
  100000014:'Site',
  100000015:'Livro Branco',
  100000016:'Explorador de blockchain',
  100000017:'Pontuação do Projeto',
  100000018:'Classificação',
  100000019:'Top',
  100000020:'Code security',
  100000021:'Operation Performance',
  100000022:'Market Stability',
  100000023:'Governance Strength',
  100000024:'Project Health',
  100000025:'Community Trust',
  100000026:'Tempo Atualizado',
  100000027:'Pontuação de segurança',
  100000028:'Pontuação de segurança do contrato',
  100000029:'Estatísticas de projetos de risco',
  100000030:'Detalhes do código do contrato',
  100000031:'Imposto de Compra',
  100000032:'Imposto de Venda',
  100000033:'É Armadilha?',
  100000034:'É possivelmente mintável.',
  100000035:'Tem Lista Negra',
  100000036:'Tem lista branca?',
  100000037:'Anti-baleia',
  100000038:'Pode alterar a taxa de imposto',
  100000039:'Não é código aberto',
  100000040:'Possui Proprietário Oculto',
  100000041:'Pode auto-destruir',
  100000042:'É um contrato de proxy?',
  100000043:'Pode alterar o saldo',
  100000044:'Possui Chamadas Externas',
  100000045:'Pode Recuperar a Propriedade',
  100000046:'Existe Período de Espera para Transferências',
  100000047:'Transferência pode ser pausada?',
  100000048:'Propriedade Não Renunciada',
  100000049:'É Modificável Anti-Baleia',
  100000050:'Decimal muito pequeno',
  100000051:'Métodos Públicos de Mintar e Queimar',
  100000052:'A queima deve atualizar a oferta total',
  100000053:'Queimar deve atualizar a permissão',
  100000054:'Transferência interna pode dobrar o saldo',
  100000055:'Transferir mais que o saldo deve falhar',
  100000056:'Saldo não atualizado durante a transferência',
  100000057:'Transferência Não Deve Usar Saldo do Gastador',
  100000058:'Transferência acima da autorização excede saldo disponível',
  100000059:'O método BurnFrom deve atualizar o suprimento total.',
  100000060:'Detecte o imposto de compra do token. Acima de 5% é considerado uma alta taxa.',
  100000061:'Detecte o imposto sobre a venda do token. Acima de 5% é considerado alta taxa.',
  100000062:'Verifique se o token é uma fraude honeypot',
  100000063:'Verifique se mais tokens podem ser criados.',
  100000064:'Verifique se o token possui uma lista negra que pode restringir os usuários de trocar ou transferir tokens.',
  100000065:'Verifique se o token possui uma lista de permissões que permite endereços ignorarem restrições.',
  100000066:'Verifique se o token possui mecanismos anti-baleia.',
  100000067:'Verifique se o token tem um imposto e se ele pode ser modificado por funções privilegiadas.',
  100000068:'Verifique se o token foi verificado no explorador de blockchain.',
  100000069:'Verifique se o token tem um proprietário oculto que pode manipular o contrato, mesmo que a propriedade pareça ter sido renunciada.',
  100000070:'Verifique se o token pode se autodestruir.',
  100000071:'Verifique se o token é um contrato proxy que delega chamadas de função a um contrato de implementação.',
  100000072:'Verifique se o saldo do token pode ser modificado por roles privilegiadas.',
  100000073:'Verifique se o token chama contratos externos',
  100000074:'Verifique se o token tem uma porta dos fundos para recuperar a propriedade.',
  100000075:'Verifique se o token possui um mecanismo de resfriamento de transferência.',
  100000076:'Verifique se o comércio do token pode ser pausado por papéis privilegiados.',
  100000077:'Verifique se o privilégio do proprietário foi renunciado.',
  100000078:'Verifique se os mecanismos anti-baleia do token podem ser modificados por papéis privilegiados.',
  100000079:'Verifique se o valor de retorno da função `decimals()` é maior ou igual a 5.',
  100000080:'Verifique se a chamada das funções `mint()` e `burn()` por usuários aleatórios causará revert.',
  100000081:'Verifique se chamar a função `burn()` atualizará corretamente o `totalSupply`.',
  100000082:"Verifique se chamar a função `burnFrom()` atualizará a concessão corretamente.",
  100000083:'Verifique se chamar a função `transfer()` com o destinatário igual ao remetente da transação aumentará o saldo do remetente.',
  100000084:'Verifique se a chamada da função `transfer()` com um valor maior que o saldo falhará.',
  100000085:"Verifique se a autorização do gastador foi atualizada adequadamente após chamar a função `transferFrom()`.",
  100000086:"Verifique se chamar a função `transferFrom()` usará o saldo do gastador.",
  100000087:"Verifique se a aprovação é atualizada corretamente após chamar `transferFrom()`, ou se a transação falha se o valor for inválido.",
  100000088:"Verifique se chamar a função `burnFrom()` atualizará corretamente o `totalSupply`.",
  100000089:'Verifique se a autoridade de emissão existe',
  100000090:'Verificar se a autoridade de congelamento existe',
  100000091:'Verifica se os metadados podem ser alterados',
  100000092:'Crítico',
  100000093:'Sério',
  100000094:'Médio',
  100000095:'Leve',
  100000096:'Informação',
  100000097:'Autoridade de mint foi revogada',
  100000098:'A autoridade de congelamento foi revogada',
  100000099:'É possível alterar os metadados.',

  100000100:'Seu relatório anual está sendo gerado…',
  100000101:'Bem-vindo à',
  100000102:'Sua revisão de 2024',
  100000103:'Eu sou seu guia pessoal',
  100000104:'aqui para guiá-lo pelas pegadas de sua jornada em 2024',
  100000105:'Abrir relatório',
  100000106:'{num} dias atrás, as rodas do destino começaram a girar.',
  100000107:'{userName} Notre histoire commence à partir d\'ici',
  100000108:'Juntos, corremos em direção a um sonho compartilhado.',
  100000109:'Estrelas de investimento',
  100000110:'Visão Geral Anual da Carteira - Taxa de Rendimento Total',
  100000111:'Você está à frente de <em class="normal bold" style="color: #2AFF0A;">{percentage}</em> dos usuários',
  100000112:'No último ano, vivemos o <em class="normal bold" style="color: #FFF;">FOMO</em> trazido pelas inscrições e desfrutamos da alegria da <em class="normal bold" style="color: #FFF;">meme alta</em>. Agora, vamos mergulhar juntos em suas memórias.',
  100000113:'Trade Estrela',
  100000114:'Transações acumuladas em 2024 (vezes)',
  100000115:'Valor acumulado da transação ($)',
  100000116:'Você ultrapassou <em class="normal bold" style="color: #FFC72B;">{percentage}%</em> dos usuários.',
  100000117:'Esta não é apenas uma conquista numérica, mas também um emblema da sua visão e sabedoria.',
  100000118:'Cada negociação é um passo em direção à Web3.0.',
  100000119:'Estrela em ascensão',
  100000120:'A maior queda do Bitcoin em 2024 atingiu <em class="normal">34%</em>. As correções do mercado são a norma e o desempenho do seu investimento é apenas uma fase – um grande potencial está por vir!',
  100000121:'Investidor estável',
  100000122:'Cada observação e espera era para preparar um momento mais preciso. Esperamos ver seus milagres de investimento em lucros em 2025.',
  100000123:'Token mais negociado em 2024',
  100000124:'Aquilo que você segura ecoa de volta.',
  100000125:'Seu foco e esforço já brilharam em seus resultados comerciais.',
  100000126:'Desempenho do Bitcoin no SuperEx em 2024',
  100000127:'Sua variação de preço do Bitcoin em 2024',
  100000128:'Parabéns por aumentar seus ativos! Mantenha o ritmo no próximo ano.',
  100000129:'Em 2024, você não tinha Bitcoin.',
  100000130:'Excelente Investidor',
  100000131:'Investidor estável',
  100000132:'Investidor de Aprendiz',
  100000133:'Seus principais dados comerciais no mercado',
  100000134:'rendimento($)',
  100000135:'Retorno anualizado (%)',
  100000136:'Classificação de lucro (%)',
  100000137:'Seus dados de negociação de contrato',
  100000138:'Sua estratégia de negociação demonstra sua sabedoria – obrigado por escolher ser nosso parceiro!',
  100000139:'Velejando para o Futuro',
  100000140:'Você não apenas acompanha as tendências, mas também é um precursor delas! Você lançou moedas na zona livre <em class="normal bold" style="color: #FFF;">{num1}</em> vezes e negociou <em class="normal bold" style="color: #FFF;">{num2}</em> vezes. Você, que adora produtos inovadores, é o verdadeiro aventureiro!',
  100000141:'Super estrela social',
  100000142:'Obrigado por trazer <em class="normal bold" style="color: #FFF;">{num}</em> novos usuários para nossa plataforma. Suas indicações impulsionaram nosso crescimento. Esperamos que mais pessoas com ideias semelhantes se juntem a nós na jornada da Web3.0.',
  100000143:'Estrela social em ascensão',
  100000144:'Os <em class="normal bold" style="color: #FFF;">{num}</em> usuários da SuperEx ganharam até 40% em comissões de negociação ao convidar amigos. Se você perdeu 2024, não se preocupe – aproveite a chance em 2025.',
  100000145:'Compartilhe seus destaques anuais com sua comunidade, incentive mais pessoas a se juntarem a nós e desbloqueie recompensas exclusivas enquanto exploram o mundo criptográfico juntos!',
  100000146:'Convide um amigo para receber uma recompensa no valor de 10 USDT!',
  100000147:'Compartilhar relatório',
  100000148:'Ver novamente',
  100000149:'Em 2024, você foi conhecido no SuperEx como',
  100000150:'Você superou os usuários da plataforma:',
  100000151:'Mercado principal Negociação à vista Rendimento Anual',
  100000152:'Contrato Rendimento Anual',
  100000153:'Este ano, sou uma lenda do investimento!',
  100000154:'Código de referência: {InviteCode}',
  100000155:'SuperEx.com - Web3.0 exchange de criptomoedas',
  100000156:'Vitórias constantes, força revelada!',
  100000157:'Este ano, experiência adquirida, ano que vem será ainda melhor!',
  100000158:'Você sabia?',
  100000159:'A zona de livre comércio da SuperEx é a plataforma de negociação de Meme coins mais quente e promissora do mundo.',
  100000160:'2024, superex adiciona <em class="normal bold" style="color: #FFF;">{num}</em> usuários, como nova família',
  100000161:'Sua revisão de 2024 e a jornada para lucros mil vezes em 2025 estão prestes a começar.',
  100000162:'Esta é uma carta de um membro sênior da família Superex, registrando suas boas notícias para 2024.',
  100000163:'@to*** comprou 1 BTC com 1 USDT, com um rendimento de até <em class="normal bold" style="color: #FFF;font-size:0.7rem">9,958,800%</em>.',
  100000164:'@1o*** obteve 1 ETH por 1 USDT, com um retorno de até <em class="normal bold" style="color: #FFF;font-size:0.7rem">487,000%</em>.',
  100000165:'@we*** obteve 1 iPhone 15 por 1 USDT, com uma taxa de retorno de <em class="normal bold" style="color: #FFF;font-size:0.7rem">92,800%</em>.',
  100000166:'Há ainda mais coisas empolgantes…',
  100000167:'Pequenos investimentos, grandes retornos, e jogabilidade em constante evolução tornam cada participação cheia de surpresas.',
  100000168:'Spot, contrato, gestão de patrimônio…',
  100000169:'A carta é longa, vamos continuar lendo',
  100000170:'Emissão acumulada de tokens iniciais de <span class="inline-block relative bold" style="color: #FFFFFF;font-size:1rem">150+</span>, SuperEx continuará a se esforçar para criar mais oportunidades para os usuários',
  100000171:'Resumo anual da carteira Taxa de P&L acumulada da conta',
  100000172:'Visão geral da carteira Conta Montante anual de lucro e prejuízo <em class="normal bold {classNum}">{num}</em>',
  100000173:'Você está à frente de <em class="normal bold" style="color: #FFF;font-size:1rem">{percentage}%</em> dos usuários. Sua sabedoria em estratégias de investimento é impressionante.',
  100000174:'2025-SuperEx',
  100000175:'Caminho para a riqueza',
  100000176:'Abra quando estiver pronto',
  100000177:'Olá! Eu sou um novo amigo da SuperEx.',
  100000178:'Junte-se ao SuperEx, explore possibilidades infinitas, registre-se para aproveitar os benefícios para novos usuários.',
  100000179:'Usuário @vb*** participa na negociação no mercado principal ao spot, com uma taxa de retorno acumulado de quase <em class="normal bold" style="color: #FFF;font-size:0.7rem">10,400%</em> para $ATOM.',
  100000180:'Usuário @xi*** participa na negociação no mercado principal à vista, o retorno acumulado de $PIPE é quase <em class="normal bold" style="color: #FFF;font-size:0.7rem">7,400%</em>.',
  100000181:'O usuário @09*** participa na negociação principal de $ATH com um retorno acumulado de quase <em class="normal bold" style="color: #FFF;font-size:0.7rem">3,500%</em>.',
  100000182:'Estamos ansiosos para testemunhar sua primeira negociação na exchange WEB3 e iniciar um capítulo empolgante!',
  100000183:'1USD, Super Start, 1000+em ações, 150X alavance, 1000X inscrição…',
  100000184:'Experimente vários setores de alta rentabilidade!',
  100000185:'As subidas e descidas são passageiras, mas a fé permanece.',
  100000186:'Atravessando a volatilidade, testemunhe o verdadeiro valor.',
  100000187:'Seu relatório anual de 2024 ainda não foi gerado. Bem-vindo a uma nova jornada de negociações! Acumule mais interações para desbloquear o resumo exclusivo do próximo ano!',
  100000188:'A história anual da criptomoeda de 2024 está esperando sua análise! Reviva os momentos marcantes de 2024 com o SuperEx, venha compartilhar seus momentos exclusivos! ',
  100000189:'A história anual da criptomoeda de 2024 está esperando sua análise!',
  100000190: 'Abra o aplicativo SuperEx para visualizar o “Relatório anual”',
  100000191: '{year}ano {month}mês {day}dia (UTC)',
  100000192: 'Comprador',
  100000193: 'Código de pedido',
  100000194: 'Eu',
  100000195: 'Lista de participantes',
  100000196: 'Os itens de moeda digital foram emitidos. Por favor, entre em contato com o serviço ao cliente para itens físicos',
  100000197: 'Compra bem-sucedida',
  100000198: '{name}obtido com sucesso',
  100000199: 'Comprar',
  100000200: 'Tudo carregado',
  100000201: 'Parabéns a {name} por ganhar {shop}!',
  100000202: 'Usuário {name} entrou em {shop} com sucesso!'

}
export default pt


// WEBPACK FOOTER //
// ./src/i18n/langs/languageAllen/pt.js